import React, { useEffect, useState } from 'react';
import {
	X,
} from 'react-bootstrap-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
	Navigation,
	Pagination,
	Mousewheel,
	Keyboard,
} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { removeRightClick } from '../utilities/util';

SwiperCore.use([Navigation, Pagination, Mousewheel, Keyboard]);
export default function CollectionListViewer(props) {
	const [selected, setSelected] = useState(1);
	const { collection, apiService, isadg } = props;
	//console.log(props);
	const closeCollectionList = () => {
		document.getElementById('collections-list').classList.remove('show');
		document
			.getElementById('collections-list-info')
			.classList.remove('show');
	};
	useEffect(() => {
		if (!collection.isLoading) {
			const sel =
				collection.payload?.collections
					?.findIndex((item) => isadg.includes(item.code)) ?? 0;
			setSelected(sel + 1);
		}
	}, [collection.isLoading, collection.payload.collections, isadg]);
	return (
		<>
				<div
					id='collections-list-info'
					className='collections-list-info'>
					<div className='collections-list-info-cnt'>
			{!collection.isLoading && (
						<div className='collections-list-info-text'>
							Elemento {selected === 0 ? 1 : selected} de{' '}
							{collection.payload.collections?.length > 0
								? collection.payload.collections.length
								: 1}{' '}
							en la colección
						</div>
			)}
						<span className='collections-list-close-icon'>
							<X onClick={closeCollectionList} />
						</span>
					</div>
				</div>
			<div id='collections-list' className='collections-list'>
				{/* <div className='collections-list-close'>
					<span className='collections-list-close-icon'>
						<X onClick={closeCollectionList} />
					</span>
				</div> */}

				<div className='navigation-container'>
					{collection.isLoading && (
						<div className='loading'>Loading...</div>
					)}
					<Swiper
						cssMode={true}
						navigation={true}
						spaceBetween={30}
						keyboard={true}
						freeMode={true}
						breakpoints={{
							// when window width is >= 640px
							480: {
								width: 480,
								slidesPerView: 1,
							},
							640: {
								width: 640,
								slidesPerView: 2,
							},

							// when window width is >= 768px
							768: {
								width: 768,
								slidesPerView: 4,
							},
							1024: {
								width: 1024,
								slidesPerView: 4,
							},
						}}
						className='collections-slider'>
						{collection.isLoading && <div>Loading...</div>}
						{!collection.isLoading &&
							collection.payload.collections?.length > 0 &&
							collection.payload.collections.map((item, indx) => {
								//&& setSelected(indx + 1);
								return (
									<SwiperSlide
										key={indx}
										className='item-slider'>
										<a
											className='item-collection'
											href={`${process.env.PUBLIC_URL}/item/${item.code}`}>
											<img
												className='item-collection-image'
												src={apiService.__getThumbSrcIcon(
													item.digitalfile?.file_id,
													100,
													isadg.includes('GT-CIRMA-FG') ? 'GT-CIRMA-FG' : 'GT-CIRMA-AH'
												)}
												alt={item?.display_name}
												loading='lazy'
												onContextMenu={removeRightClick}
											/>
											<div className='position-info'>
												{`${indx + 1}/${
													collection.payload
														?.collections.length
												}`}
											</div>
											<h5 className='collection-code'>
												{item?.code}
											</h5>
											<span className='collection-name'>
												{item?.display_name}
											</span>
										</a>
									</SwiperSlide>
								);
							})}
						{!collection.isLoading &&
							!collection.payload.collections?.length && (
								<SwiperSlide className='item-slider'>
									<a
										className='item-collection'
										href={`${process.env.PUBLIC_URL}/item/${isadg}`}>
										<img
											className='item-collection-image'
											src={`${props.img}?w=100`}
											alt={
												collection.payload.collection
													?.display_name
											}
											loading='lazy'
											onContextMenu={removeRightClick}
										/>
										<div className='position-info'>
											{`${1}/${1}`}
										</div>
										<h5 className='collection-code'>
											{isadg}
										</h5>
										<span className='collection-name'>
											{
												collection.payload.collection
													?.display_name
											}
										</span>
									</a>
								</SwiperSlide>
							)}
					</Swiper>
					{/* <div className='navigation-left'>
						<Button
							variant='transparent'
							className='navigation-button'>
							<ChevronBarLeft color='black' size={25} />
						</Button>
						<Button
							variant='transparent'
							className='navigation-button'>
							<ChevronLeft color='black' size={25} />
						</Button>
					</div>
					<ul>
						{collection.isLoading && <li>Loading...</li>}
						{!collection.isLoading &&
							collection.payload.collections.length > 0 &&
							collection.payload.collections.map((item, indx) => {
								if (indx >= 4) return '';
								console.log(item);
								return (
									<li key={indx} className='item-slider'>
										<a
											className='item-collection'
											href={`${process.env.PUBLIC_URL}/item/${item.code}`}>
											<img
												className='item-collection-image'
												src='https://picsum.photos/200/300'
												alt={item.display_name}
												loading='lazy'
											/>
											<div className='position-info'>
												{`${indx + 1}/${
													collection.payload
														.collections.length
												}`}
											</div>
											<h5 className='collection-code'>
												{item.code}
											</h5>
											<span className='collection-name'>
												{item.display_name}
											</span>
										</a>
									</li>
								);
							})}
					</ul>
					<div className='navigation-right'>
						<Button
							variant='transparent'
							className='navigation-button'>
							<ChevronRight color='black' size={30} />
						</Button>
						<Button
							variant='transparent'
							className='navigation-button'>
							<ChevronBarRight color='black' size={30} />
						</Button>
					</div> */}
				</div>
			</div>
		</>
	);
}
